((isSupported) => {
  if (!isSupported) {
    let data = {};
    window.localStorage = {
      setItem: (id, val) => { data[id] = String(val); return data[id]; },
      getItem: (id) => (Object.prototype.hasOwnProperty.call(data, id) ? data[id] : null),
      removeItem: (id) => delete data[id],
      clear: () => { data = {}; },
    };
  }
})(((key) => {
  try {
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
})('test'));
